export const COLORS = {
  phq9: "#845EF4",
  gad7: "#0B92FE",
  phq9Label: "#B6A0F8",
  gad7Label: "#80C6FE",
  pageBg: "#F5F7FA",
  cardBg: "#FFFFFF",
  heading: "#1E293B",
  body: "#64748B",
  primary: "#3893CC",
  border: "#E2E8F0",
  sectionTitle: "#475569",
  headerBorder: "#D7DCE4",
  innerCardBg: "#FCFCFD",
  innerCardBorder: "#D1D7E0",
  helperText: "#94A3B8",
};

export const highRiskData = {
  phq9: { count: 7, period: "Last 90 days", criteria: "PHQ-9 >= 20" },
  gad7: { count: 5, period: "Last 90 days", criteria: "GAD-7 >= 15" },
};

export const totalPatientsByCondition = {
  phq9: { count: 120, period: "Last 90 days", condition: "Depression" },
  gad7: { count: 95, period: "Last 90 days", condition: "Anxiety" },
};

const makeMetric = (rate, eligible, positive, negative, excluded) => ({
  rate,
  eligible,
  positive: { count: positive.count, pct: positive.pct },
  negative: { count: negative.count, pct: negative.pct },
  excluded,
});

export const improvementData = {
  phq9_30: makeMetric("40%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7_30: makeMetric("32%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  phq9_60: makeMetric("40%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7_60: makeMetric("32%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  phq9_90: makeMetric("40%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7_90: makeMetric("32%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
};

export const worseningData = {
  phq9_30: makeMetric("44%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7_30: makeMetric("24%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  phq9_60: makeMetric("44%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7_60: makeMetric("24%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  phq9_90: makeMetric("44%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7_90: makeMetric("24%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
};

export const partialResponseData = {
  phq9: makeMetric("54%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7: makeMetric("40%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
};

export const remissionData = {
  phq9: makeMetric("34%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
  gad7: makeMetric("28%", 120, { count: 28, pct: "56%" }, { count: 28, pct: "34%" }, 28),
};

export const medianTimeData = {
  phq9: { time: "42 days", period: "Last 90 days", eligible: 120, remission: { count: 28, pct: "56%" }, excluded: 28 },
  gad7: { time: "28 days", period: "Last 90 days", eligible: 120, remission: { count: 28, pct: "56%" }, excluded: 28 },
};

export const averageScoreTrendData = {
  weeks: ["Week 1", "Week 2", "Week 3", "Week 4"],
  phq9: [13.5, 13, 11, 10.5],
  gad7: [12, 11.5, 11, 10],
};

export const totalAssessmentsData = {
  categories: ["Jan 2026", "Feb 2026", "Mar 2026", "Apr 2026"],
  phq9: [89, 97, 170, 156],
  gad7: [76, 120, 167, 152],
};

export const severityPHQ9Data = {
  categories: ["Minimal", "Mild", "Moderate", "Moderately severe", "Severe"],
  values: [85, 120, 95, 60, 35],
};

export const severityGAD7Data = {
  categories: ["Minimal", "Mild", "Moderate", "Severe"],
  values: [90, 110, 80, 40],
};

export const filterOptions = {
  clinicNames: [
    { value: "", label: "Select clinic name" },
    { value: "clinic1", label: "Clinic 1" },
    { value: "clinic2", label: "Clinic 2" },
    { value: "clinic3", label: "Clinic 3" },
  ],
  patientNames: [
    { value: "", label: "Select patient name" },
  ],
  assessmentTypes: [
    { value: "", label: "All" },
    { value: "phq9", label: "PHQ-9" },
    { value: "gad7", label: "GAD-7" },
    { value: "insomnia", label: "Insomnia (ISI)" },
    { value: "promis-pain-8", label: "PROMIS Pain-8" },
  ],
  genders: [
    { value: "Female", label: "Female" },
    { value: "Male", label: "Male" },
    {
      value: "Female-to-Male (FTM)/Transgender Male/Trans Man",
      label: "Female-to-Male (FTM)/Transgender Male/Trans Man",
    },
    {
      value: "Male-to-Female (MTF)/Transgender Female/Trans Woman",
      label: "Male-to-Female (MTF)/Transgender Female/Trans Woman",
    },
    {
      value: "Genderqueer, neither exclusively male nor female",
      label: "Genderqueer, neither exclusively male nor female",
    },
    { value: "Unknown", label: "Unknown" },
    { value: "OTHER", label: "Other" },
    { value: "NON_BINARY", label: "Non-Binary" },
    { value: "NO_ANSWER", label: "Prefer not to answer" },
  ],
  ageRanges: [
    { value: "", label: "All Age Ranges" },
    { value: "0-12", label: "0-12" },
    { value: "13-17", label: "13-17" },
    { value: "18-25", label: "18-25" },
    { value: "26-40", label: "26-40" },
    { value: "41-60", label: "41-60" },
    { value: "60+", label: "60+" },
  ],
  timeInCare: [
    { value: "", label: "All Time in Care" },
    { value: "last_30_days", label: "Last 30 Days" },
    { value: "last_60_days", label: "Last 60 Days" },
    { value: "last_90_days", label: "Last 90 Days" },
    { value: "last_120_days", label: "Last 120 Days" },
    { value: "last_150_days", label: "Last 150 Days" },
    { value: "last_180_days", label: "Last 180 Days" },
    { value: "last_210_days", label: "Last 210 Days" },
    { value: "last_240_days", label: "Last 240 Days" },
    { value: "last_270_days", label: "Last 270 Days" },
    { value: "last_300_days", label: "Last 300 Days" },
    { value: "last_330_days", label: "Last 330 Days" },
    { value: "last_360_days", label: "Last 360 Days" },
    { value: "last_6_months", label: "Last 6 Months" },
    { value: "ytd", label: "Year to Date (YTD)" },
  ],
  timeRanges: [
    { value: "30", label: "Last 30 days" },
    { value: "60", label: "Last 60 days" },
    { value: "90", label: "Last 90 days" },
  ],
};
